import { generateUtilityClass } from '@mui/base/generateUtilityClass';
import { generateUtilityClasses } from '@mui/base/generateUtilityClasses';
export function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiOriDialog', slot);
}
export const dialogClasses = generateUtilityClasses('MuiOriDialog', ['root', 'header', 'content']);
export default dialogClasses;
//# sourceMappingURL=dialogClasses.js.map